const ProductTemplate = {
  type: 'Product',
  title: 'Product Templates',
  formTitle: 'Product Templates',
  formUrl: '/Products/ProductTemplate/Details/',
  workspaceUrl: '/Products/ProductTemplate/Workspace',
  screenReference: 'PRODUCT_TEMPLATES',
};

export default ProductTemplate;
